import { Route, Routes } from 'react-router-dom';
import { CustomerLogin } from './login';
import { RouteDataProvider } from './RouteDataContext';
import PrivateRoute from './PrivateRoute';
import { PageHeader } from './customer/header';
import { PageTermsCondition } from './customer/page';
import AddressVerifictionRoute from './customer/addressVerificationLink/route';
import { CustomerLoginWithoutPassword } from './login-without-password';
import PhoneUpdateMain from './phoneEmailUpdate/updatePhone/phoneUpdateMain';
import { UpdateInfo } from './phoneEmailUpdate/updateInfo';
import { CustomerLoginWithoutRedemness } from './login-without-redemness';


const CustomerRoute = () => {
    // const companyLocal = localStorage.getItem('company')
    // const companyLogged = localStorage.getItem('company_login') || null;
    const userData: any = JSON.parse(localStorage.getItem('cuslogin') || 'null');
    // Check if the user is logged in
    const isLoggedIn = userData && userData.api_token; // Assuming 'id' exists if logged in

    return (
        <RouteDataProvider>
            <Routes>
                {/* <Route path='/pincode' element={<GetDistanceFromPincode />} /> */}
                <Route path='/:companyname/:key/:memberid/:mobile/:user_type/:user_name/:total_point/:address' element={<CustomerLoginWithoutPassword />} />
                <Route path='kyc/:companyname/:key/:memberid/:mobile' element={<CustomerLoginWithoutRedemness />} />
                <Route
                    path="/:company/terms-condition"
                    element={
                        <div className=''>
                            <PageHeader heading="Terms of Use / Privacy Policy" />
                            <PageTermsCondition />
                        </div>
                    }
                />
                <Route path='/address/*' element={<AddressVerifictionRoute />} />
                <Route path='/update_phone_email/:type' element={<PhoneUpdateMain />} />
                <Route path='/update-info' element={<UpdateInfo />} />
                {!isLoggedIn ? (
                    // If user is not logged in, render the login page
                    <>
                        <Route path='/:company/login' element={<CustomerLogin />} />
                        {/* <Route path='/:companyname/:key/:memberid/:mobile/:user_type/:user_name/:total_point/:address' element={<CustomerLoginWithoutPassword />} /> */}
                    </>
                ) : (
                    <>
                        <Route path='*' element={<PrivateRoute />} />
                    </>
                )}

            </Routes>
        </RouteDataProvider>
    );
};

export default CustomerRoute;


